import {
  disableFormSubmit,
  enableFormSubmit,
  positionWindowAtFormElement,
  validate,
} from './utils/form-validation-utils';
import {
  subscribeLead,
} from './utils/drip-utils';

export default class EpiserverLeadFormManager {
  constructor(options) {
    if (options === null || options.form === null) {
      return;
    }
    const { form } = options;
    this.form = form;
    this.formBtn = form.querySelector('.o-form__submit');
    this.errDiv = form.querySelector('.Form__Errors');
    this.errMsgDiv = form.querySelector('.Form__Errors .error-msg');
    this.isErrDiv = this.errDiv && this.errMsgDiv;
    this.origErrMsg = this.isErrDiv ? this.errMsgDiv.textContent : '';
    this.displaySelector = 'hidden';

    const formConfirmationDiv = form.querySelector('.Form__Confirmation');
    const formMainBodyDiv = form.querySelector('.Form__MainBody');
    const that = this;

    // Look for data-success-callback, data-on-submit on form
    const {
      disableErrorScroll,
      submitCallback,
      successCallback,
    } = form.dataset;

    this.formBtn.addEventListener('click', (event) => {
      event.preventDefault();
      disableFormSubmit(form);
      if (validate(form)) {
        subscribeLead({
          fail: () => {
            that.displayErrorMessage(that.origErrMsg);
          },
          form,
          success: (data) => {
            if (data.status !== undefined && data.status !== 200) {
              that.displayErrorMessage(data.detail);
              return;
            }
            if (data.Error !== undefined) {
              that.displayErrorMessage(data.Error);
              return;
            }
            if (that.isErrDiv) {
              that.errDiv.classList.add(that.displaySelector);
            }
            if (formMainBodyDiv) {
              formMainBodyDiv.classList.add(that.displaySelector);
            }
            if (formConfirmationDiv) {
              formConfirmationDiv.classList.remove(that.displaySelector);
            }
            if (successCallback && typeof window[successCallback] === 'function') {
              window[successCallback]();
            }
          },
        });
        if (submitCallback && typeof window[submitCallback] === 'function') {
          window[submitCallback]();
        }
      } else {
        enableFormSubmit(form);
        const offset = document.querySelector('.header') ? document.querySelector('.header').offsetHeight + 10 : 10;
        if (disableErrorScroll === 'true') return;
        positionWindowAtFormElement({
          element: form.querySelectorAll('.ValidationFail')[0],
          offset: -offset,
        });
      }
    });
  }

  displayErrorMessage(msg) {
    const {
      displaySelector,
      errDiv,
      errMsgDiv,
      form,
      isErrDiv,
    } = this;
    enableFormSubmit(form);
    if (isErrDiv) {
      errMsgDiv.textContent = msg;
      errDiv.classList.remove(displaySelector);
    }
  }
}

(() => {
  const formSelector = '.episerver-lead-form';
  const formList = document.querySelectorAll(formSelector);
  formList.forEach((form) => {
    const episerverLeadFormManager = new EpiserverLeadFormManager({ form }); /* eslint-disable-line no-unused-vars */
  });
})();
